import { isWeakSet as isWeakSet$1 } from '../../predicate/isWeakSet.mjs';

function isWeakSet(value) {
    return isWeakSet$1(value);
}

export { isWeakSet };
